import {pay_manage_http, http, hr_http, pay_manage_url, ajaxUrl, pay_manage_http_upload } from '@/libs/util'
import util, {ajax_download } from '@/libs/util'
import host from '@/config/host.js'
const secret = host.secret
export const { 
    customer_month_salary_total_list,
    customer_basic_salary_info_page,
    customer_basic_salary_info_detail,
    customer_basic_salary_update_salary,
    customer_basic_salary_batch_update_salary,
    customer_basic_salary_history_list,
    customer_insurance_payment_base_get_base,
    customer_insurance_payment_base_update_base,
    customer_insurance_payment_ratio_get_ratio,
    customer_insurance_payment_ratio_update_ratio,
    customer_month_salary_total_detail_list,
    customer_month_salary_total_pigeonhole,
    customer_month_salary_total_detail_count,
    customer_month_salary_total_modify_detail,
    customer_meal_subsidy_list,
    customer_meal_subsidy_update,
    customer_month_salary_total_recommend_award_detail,
    hr_wxdata_financial_clock_in_data_of_customer,
    customer_month_salary_total_import_salary_detail_info,
    customer_month_salary_total_download_detail,
    customer_month_salary_total_current_month_pay,
    customer_basic_salary_confirm,
    customer_basic_salary_import_basic_salary,
    customer_basic_salary_save_insurance_change_info,
    customer_basic_salary_insurance_change_history,
    customer_salary_adjust_apply_save,
    customer_salary_adjust_batch_template,
    customer_salary_adjust_apply_batch_apply_save,
    customer_salary_adjust_apply_delete,
    customer_salary_adjust_apply_down_batch_adjust,
    customer_basic_salary_init_import_template,
    customer_month_salary_total_down_init_template_file,
    customer_month_salary_total_import_init_data,
    customer_salary_payment_apply_delete,
    customer_month_salary_total_transfer_wage,
    customer_month_salary_total_pay_salary,
    customer_basic_salary_rebut,
    customer_month_salary_total_company_month_salary_info,
    customer_month_salary_total_down_import_templete
 } = util.api || {}

// 获取薪资发放-薪资概要
export function getCustomerMonthSalaryTotalListApi(params) {
    return pay_manage_http.get(customer_month_salary_total_list, params)
}

// 获取薪酬列表
export function getCustomerBasicSalaryInfoPageApi(params) {
    return pay_manage_http.get(customer_basic_salary_info_page, params)
}

// 获取个人薪酬相关
export function getCustomerBasicSalaryInfoApi(params) {
    return pay_manage_http.get(customer_basic_salary_info_detail, params)
}

// 获取修改薪酬历史
export function getSalaryHistoryListApi(params) {
    return pay_manage_http.get(customer_basic_salary_history_list, params)
}

// 获取存缴基数
export function getPaymentBaseGetBaseListApi(params) {
    return pay_manage_http.get(customer_insurance_payment_base_get_base, params)
}

// 获取存缴比例
export function getpaymentRatioGetRatioApi(params) {
    return pay_manage_http.get(customer_insurance_payment_ratio_get_ratio, params)
}

// 获取缴存
export function getSubsidizedMealsSetDetailApi(params) {
    return pay_manage_http.get(customer_meal_subsidy_list, params)
}

// 单独修改薪酬
export function ediCustomerBasicSalaryUpdateSalaryApi(params) {
    return pay_manage_http.post(customer_basic_salary_update_salary, params)
}

// 批量修改薪酬
export function ediCustomerBasicSalaryBatchUpdateSalaryApi(params) {
    return pay_manage_http.post(customer_basic_salary_batch_update_salary, params)
}

// 修改基数
export function editInsurancePaymentBaseUpdateBaseApi(params) {
    return pay_manage_http.post(customer_insurance_payment_base_update_base, params)
}
// 修改餐补
export function editSubsidizedMealsSetApi(params) {
    return pay_manage_http.post(customer_meal_subsidy_update, params)
}

//修改存缴比例
export function editUpdateRatioApi(params) {
    // customer_insurance_payment_ratio_update_ratio
    return pay_manage_http.post(customer_insurance_payment_ratio_update_ratio, params)
}

// 薪资明细查询接口
// customer_month_salary_total_detail_list
export function getCustomerMonthSalaryTotalDetailListApi(params) {
    return pay_manage_http.get(customer_month_salary_total_detail_list, params)
}

// 归档

export function pigeonholeApi(params) {
    return pay_manage_http.get(customer_month_salary_total_pigeonhole, params)
}

// 薪酬管理统计
export function getSalaryBreakdownStatisticsApi(params) {
    return pay_manage_http.get(customer_month_salary_total_detail_count, params)
}

// 调整
export function adjustApi(params) {
    return pay_manage_http.post(customer_month_salary_total_modify_detail, params)
}

// 获取推荐奖励明细
export function getEmployeeMonthSalaryAwardDetailApi(params) {
    return pay_manage_http.get(customer_month_salary_total_recommend_award_detail, params)
}

export function getCheckingInDetailApi(params) {
    return hr_http.post(hr_wxdata_financial_clock_in_data_of_customer, params)
}
// 导入数据
export function importCustomerMonthSalaryTotalApi(params) {
    return pay_manage_http_upload.post_upload(customer_month_salary_total_import_salary_detail_info, params)
}

export function exportTempt(id) {
    window.open(`${pay_manage_url}/${customer_month_salary_total_down_import_templete}?id=${id}`, '_blank')
}

export function exportFailFileApi(fail_file) {
    window.open(`${pay_manage_url}/customer_month_salary_total/down_fail_file?fail_file=${fail_file}`, '_blank') 
}

export function exportDetailFileApi(params) {
    // eslint-disable-next-line
    const {total_id, total_count, cur_page, page,per_page, ...other_params} = params
    const _other_params = {
        id:total_id,
        ...other_params,
    }
    const str = []
    Object.keys(_other_params).forEach(key => {
        if (['', null, undefined].includes(_other_params[key])) {
            return 
        }
        str.push(`${key}=${_other_params[key]}`)
    })
    window.open(`${pay_manage_url}/${customer_month_salary_total_download_detail}?${str.join('&')}`, '_blank') 
}

export function getCustomerMonthSalaryTotalCurrentMonthPayApi(params) {
    return pay_manage_http.get(customer_month_salary_total_current_month_pay, params)
}

// 薪资确认

export function postCustomerBasicSalaryConfirmApi(params) {
    return pay_manage_http.post(customer_basic_salary_confirm, params)
}
// customer_basic_salary_confirm


export const upload_url = `${secret}/api/${customer_basic_salary_import_basic_salary}`

// 调整社保公积金 customer_basic_salary_save_insurance_change_info
export function postCustomerBasicSalarySaveInsuranceChangeInfoApi(params) {
    return pay_manage_http.post(customer_basic_salary_save_insurance_change_info, params)
}

export function getCustomerBasicSalaryInsuranceChangeHistoryApi(params) {
    return pay_manage_http.get(customer_basic_salary_insurance_change_history, params)
}

export function postCustomerSalaryAdjustApplySaveApi(params) {
    return http.post(customer_salary_adjust_apply_save, params)
}

export function getDownloadTemplate() {
    window.open(`${pay_manage_url}/${customer_salary_adjust_batch_template}`, '_blank')
}
// customer_salary_adjust_apply_batch_apply_save
export function postCustomerSalaryAdjustApplyBatchApplySaveApi(params) {
    return http.post_upload(customer_salary_adjust_apply_batch_apply_save, params)
}

export function postCustomerSalaryAdjustApplyDeleteApi(params) {
    return http.post(customer_salary_adjust_apply_delete, params)
}
// customer_salary_adjust_apply_down_batch_adjust
export function getCustomerSalaryAdjustApplyDownBatchAdjustApi(params) {
    return ajax_download .get(customer_salary_adjust_apply_down_batch_adjust, {params})
}

export function CustomerSalaryAdjustApplyDownBatchAdjustApi(id) {
  return `${ajaxUrl}/${customer_salary_adjust_apply_down_batch_adjust}?id=${id}`
}

// customer_basic_salary/init_import_template
export function getDownloadInitImportTemplate() {
    return `${pay_manage_url}/${customer_basic_salary_init_import_template}`
}

export function getDownloadCustomerMonthSalaryTotalDownInitTemplateFileApi() {
    return `${pay_manage_url}/${customer_month_salary_total_down_init_template_file}`
}

export function postCustomerSalaryPaymentApplyDeleteApi(params) {
    return http.post(customer_salary_payment_apply_delete, params)
}

export function postCustomerMonthSalaryTotalTransferWageApi(params) {
    return pay_manage_http.post(customer_month_salary_total_transfer_wage, params)
}
// customer_month_salary_total_pay_salary
export function postCustomeMonthSalaryTotalPaySalaryApi(params) {
    return pay_manage_http.post(customer_month_salary_total_pay_salary, params)
}
// customer_basic_salary_rebut
export function postCustomerBasicSalaryRebutApi(params) {
    return pay_manage_http.post(customer_basic_salary_rebut, params)
}


// customer_month_salary_total_company_month_salary_info

export function getCustomerMonthSalaryTotalCompanyMonthSalaryInfoApi(params) {
    return pay_manage_http.get(customer_month_salary_total_company_month_salary_info, params)
}